import {Stack} from '../pixi_scene/game_scene/game_table/table_objects/stacks/Stack';
import {StaticData} from '../data/StaticData';
import MessageHelper from '../../../../helpers/MessageHelper';
import EventApi from '../../../../api/EventsApi';
import {Card} from '../pixi_scene/game_scene/game_table/table_objects/stacks/Card';
import {CardData} from '../data/active_data/field_config/card_stack_data/CardData';
import {DynamicData} from '../data/DynamicData';

export class ApiSendCommandsController
{
    /**
     * Запрос на удаление колод
     * @param stacks - удаляемые колоды
     */
    static deleteStacks(stacks: Stack[]) {
        MessageHelper.sendChangeStacksMessage(
            StaticData.isAdmin ? MessageHelper.TYPE_HIDE_STACKS : MessageHelper.TYPE_DELETE_STACKS,
            {ids: ApiSendCommandsController.getStacksIds(stacks)}
        );
    }

    /**
     * Запрос на перевород колод
     * @param stacks - переворачиваемые колоды
     * @param playSound - проигрывать ли соотв. звук
     */
    static flipStacks(stacks: Stack[], playSound: boolean = true): void {
        MessageHelper.sendChangeStacksMessage(MessageHelper.TYPE_FLIP_STACKS, {
            ids: ApiSendCommandsController.getStacksIds(stacks)
        });
        playSound && EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'flip'});
    }

    /**
     * Запрос на перевород карт в руке
     * @param cards - переворачиваемые карты
     * @param playSound - проигрывать ли соотв. звук
     */
    static flipCards(cards: Card[], playSound: boolean = true): void {
        if (!DynamicData.settings.canTableFlipCards) {
            return;
        }
        MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_FLIP_CARDS, {
            ids: ApiSendCommandsController.getCardsIds(cards)
        });
        playSound && EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'flip'});
    }

    /**
     * Запрос на передачу карт другому игроку
     * @param cards - передаваемые карты
     * @param playerId - идентификатор принимающего игрока
     */
    static passToPlayer(ids: number[], playerId: string): void {
        MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_MOVE_CARD_TO_PLAYER, {
            ids,
            playerId: playerId,
            flip: [],
            handIndex: 0
        });
    }

    /**
     * Запрос на блокировку колод
     * @param stacks - колоды которые необходимо заблокировать
     */
    static lockStacks(stacks: Stack[]): void {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'itemLock'});
        MessageHelper.sendChangeStacksMessage(MessageHelper.TYPE_LOCK_STACKS, {
            ids: ApiSendCommandsController.getStacksIds(stacks)
        });
    }

    /**
     * Запрос на перемешивание колод
     * @param stacks - перемешиваемые колоды
     */
    static shuffleStacks(stacks: Stack[]): void {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'shuffle'});
        MessageHelper.sendChangeStacksMessage(MessageHelper.TYPE_SHUFFLE_STACKS, {
            ids: ApiSendCommandsController.getStacksIds(stacks.filter(stack => stack.activeData.cards.length > 1))
        });
    }

    /**
     * Получить массив идентификаторов из массива колод
     * @param stacks - массив колод
     */
    static getStacksIds(stacks: Stack[]): number[] {
        return stacks.map(stack => stack.activeData.id);
    }

    /**
     * Получить массив идентификаторов из массива карт
     * @param cards - массив карт
     */
    static getCardsIds(cards: Card[]): number[] {
        return cards.map(card => card.activeData.id);
    }

    /**
     * Запрос на поворот колод
     * @param stacks - массив поворачиваемых колод
     * @param clockwise - по часовой стрелке
     */
    static rotateStacks(stacks: Stack[], clockwise: boolean = false): void {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'click'});
        MessageHelper.sendChangeStacksMessage(MessageHelper.TYPE_ROTATE_STACK, {
            ids: ApiSendCommandsController.getStacksIds(stacks),
            delta: clockwise ? StaticData.angleStep : -StaticData.angleStep
        });
    }

    /**
     * Запрос на разблокировку колод
     * @param stacks - колоды которые необходимо разблокировать
     */
    static unlockStacks(stacks: Stack[]): void {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'itemUnlock'});
        MessageHelper.sendChangeStacksMessage(MessageHelper.TYPE_UNLOCK_STACKS, {
            ids: ApiSendCommandsController.getStacksIds(stacks)
        });
    }

    /**
     * Запрос на перемещение карт внутри руки
     * @param ids - новый массив идентификаторов карт слева направо
     * @param flip - массив переворота (не используется)
     */
    public static changeHandItemsSort(ids: number[], flip: number[], playSound: boolean = true): void {
        playSound && EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'itemTakeToHand'});
        if (ids.length > 1) {
            MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_CHANGE_HAND_ITEMS_SORT, {ids, flip});
        }
    }
}
